import { get } from './';
export const getCurrencies = async () => get(`/currencies`);
